import * as moment from 'moment';
import { IUser } from 'src/views/Admin/Users/types';
import { IProfile } from 'src/views/Admin/Profiles/types';

const mapMarket = (marketItems: any) =>
  marketItems.map((item: any) => item.profile);

const mapMarketToServer = (markets: IProfile[], withVisible?: boolean) =>
  markets.map(item => ({
    profile: item,
    ...(withVisible ? { visible: true } : {}),
  }));

export const fromServer = ({
  expirationDate,
  userProfileVisibilities,
  localContentRoles,
  localUserRoles,
  ...rest
}: any) => ({
  ...rest,
  expirationDate: expirationDate && moment(expirationDate).format('YYYY-MM-DD'),
  userProfileVisibilities: mapMarket(userProfileVisibilities),
  localContentRoles: mapMarket(localContentRoles),
  localUserRoles: mapMarket(localUserRoles),
});

export const toServer = ({
  userProfileVisibilities,
  localContentRoles,
  localUserRoles,
  ...rest
}: IUser) => ({
  ...rest,
  userProfileVisibilities: mapMarketToServer(userProfileVisibilities, true),
  localContentRoles: mapMarketToServer(localContentRoles),
  localUserRoles: mapMarketToServer(localUserRoles),
});



// WEBPACK FOOTER //
// ./src/services/api/admin/users/utils/mapUser.ts